import React, { useState, useCallback, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Homepage from "./pages/Homepage/index";
import Signup from "./pages/Auth/signup";
import Signin from "./pages/Auth/signin";
import ReceivableList from "./pages/Receivable/index";
import PayableList from "./pages/Payable/index";
import DetailsInfoPdf from "./pages/Receivable/invoiceDetails";
import DetailsInfo from "./pages/Receivable/accordianDetails";
import DetailsInfoPayable from "./pages/Payable/accordionDetails";
import ForgotPassword from "./pages/Auth/forgotPassword";
import ActivationUser from "./pages/Auth/activationUser";
import PrivateRoutes from "./utils/privateRoutes";
import History from "./pages/History";
import Company from "./pages/Auth/selectCompany";
import AdminSetting from "./pages/AdminSetting/index";
import CompanyDetails from "./pages/CompanySetting/form";
import UserDetails from "./pages/UserSetting/form";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import UserProfileIndex from "pages/UserProfile";
import PageNotFound from "components/pageNotFound";
import axios from "axios";
import isTokenExpired from "helper/isTokenExpired";
import { useApiClient } from "context/ApiClientContext";
import ProtectedRoute from "pages/Auth/protectedRoute";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);

const App = () => {
  const roleId = localStorage.getItem("roleId") || "";

  const [roles, setRole] = useState({
    id: 0,
    name: "",
    description: "",
    allowadmin: false,
    allowar: false,
    allowap: false,
    allowprofile: false,
  });
  const [loading, setLoading] = useState(true);
  const apiClient = useApiClient();

  const getRoles = useCallback(async () => {
    try {
      const response = await axios.get(
        `${apiClient}/role/${roleId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
          },
        }
      );

      setRole(response.data);
    } catch (error) {
      // ErrorAlert(error);  
    } finally {
      setLoading(false);
    }
  }, [roleId, apiClient]);

  useEffect(() => {
    getRoles();
  }, [getRoles]);

  return (
    <Router>
      <ToastContainer />
      <AppRoutes roles={roles} loading={loading} />
    </Router>
  );
};

const AppRoutes = ({ roles, loading }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("loggedInID");
    localStorage.removeItem("companyId");
    localStorage.removeItem("loggedInUsername");
    localStorage.removeItem("roleId");
    localStorage.removeItem("activeTab");

    navigate("/signin");
  }, [navigate]);

  useEffect(() => {
    if (!loading && isTokenExpired(localStorage.getItem("token"))) {
      if (location.pathname !== "/forgotPassword") {
        logout();
      }
    }
  }, [loading, logout, location.pathname]);

  if (loading) {
    return null; 
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/signup" element={<Signup />} />
      <Route path="/signin" element={<Signin />} />
      <Route path="/forgotPassword" element={<ForgotPassword />} />
      <Route path="/activationPage" element={<ActivationUser />} />

      {/* Private Routes */}
      <Route element={<ProtectedRoute><PrivateRoutes /></ProtectedRoute>}>
        <Route path="/" element={<Homepage />} />

        {roles.allowar && <Route path="/account-receivable" element={<ReceivableList />} />}
        <Route path="/account-receivable/:id" element={<DetailsInfo />} />

        {roles.allowap && <Route path="/account-payable" element={<PayableList />} />}
        <Route path="/account-payable/:id" element={<DetailsInfoPayable />} />

        <Route path="/request-history" element={<History />} />
        <Route path="/company" element={<Company />} />
        <Route path="/company-details" element={<CompanyDetails />} />
        <Route path="/user-details" element={<UserDetails />} />
        <Route path="/report-pdf/:id" element={<DetailsInfoPdf />} />

        {roles.allowadmin && <Route path="/setting" element={<AdminSetting />} />}
        {roles.allowprofile && <Route path="/profile" element={<UserProfileIndex />} />}
      </Route>

      {/* Catch-all route for unrecognized URLs */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default App;